export enum ORDER_TABS {
  REQUESTED = 'requested',
  PUBLISHED = 'published',
  DISPATCHED = 'dispatched',
  ASSIGNED = 'assigned',
  EXPIRED = 'expired',
  AVAILABLE = 'available',
  BIDS = 'bids',
  PICKED_UP = 'picked_up',
  DELIVERED = 'delivered',
  BILLED = 'billed',
  CLAIMED = 'claimed',
  ARCHIVED = 'archived',
  PAID = 'paid',
}
